export default class Exemples {
  constructor() {
    function exemplesIMG() {
      var openExemple = document.querySelectorAll(".btn-exemples img");
      openExemple.forEach((exemple) => {
        exemple.addEventListener("click", (event) => {
          document
            .querySelector(".btn-exemples img.active-btn")
            .classList.remove("active-btn");
          event.target.classList.add("active-btn");

          const gallerys = document.querySelectorAll(".gallery");
          gallerys.forEach((gallery) => {
            if (gallery.id == event.target.dataset.exemples) {
              gallery.style.display = "block";
            } else {
              gallery.style.display = "none";
            }
          });
        });
      });
    }
    exemplesIMG();

    function modalExemples() {
      const galleryExmples = document.querySelectorAll(".gallery");
      galleryExmples.forEach((gallery) => {
        const imgExmples = gallery.querySelectorAll(".item");
        for (let index = 0; index < imgExmples.length; index++) {
          var thisItem = imgExmples[index];
          thisItem.addEventListener(
            "click",
            function () {
              const img = this.querySelector(".img-exemples");
              const modalBody = document.querySelector(".m-body");
              modalBody.innerHTML = `<img src="${img.src}" class="modal-img">`;

              const myModal = document.getElementById("modalGalleryOpen");
              myModal.style.display = "block";
              myModal.classList.add("in");

              var spanClose = myModal.querySelector(".close-item");

              spanClose.onclick = function () {
                myModal.style.display = "none";
              };
              window.onclick = function (e) {
                if (e.target == myModal) {
                  myModal.style.display = "none";
                }
              };
            },
            false
          );
        }
      });
    }
    modalExemples();
  }
}
